import React, { useEffect, useState } from 'react';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import { PartnerAccountsService } from 'services/PartnerAccountsService';
import { Button, message } from 'antd';
import {
  DELETE_CONFIRM,
  DELETE_ERROR,
  FETCH_ERROR,
  REQUEST_LOADING,
  SUCCESS_DELETE,
} from 'constants/alerts';
import { ActionsWrapper } from 'ui/ActionsWrapper';
import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { PartnerAccountsForm } from './PartnerAccountsForm';
import { PartnerAccountsTable } from './PartnerAccountsTable';

function PartnerAccounts() {
  useDocumentTitle('Счета партнеров');
  const { setCount } = useHeaderChanger('Счета партнеров');

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const { page, totalRows, perPage, setTotalRows, setPagination } =
    usePagination();
  const {
    state: { activeRecord, formIsActive, drawerVisible },
    openDrawer,
    closeDrawer,
    openEditForm,
    closeForm,
  } = useDrawers();

  useEffect(() => {
    fetchItems();
  }, [page, perPage]);

  const fetchItems = async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } = await PartnerAccountsService.getPartnerAccounts(
        page,
        perPage
      );

      setItems(items);
      setTotalRows(total);
      setCount(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  };

  const getNewAccounts = async () => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isAccepted = await PartnerAccountsService.getNewPartnerAccounts();

      if (isAccepted) {
        fetchItems();
        message.success('Счета успешно получены');
      }
    } catch (err) {
      message.error('Не удалось получить счета');
    } finally {
      hide();
    }
  };

  const handleDelete = async () => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isDeleted = await PartnerAccountsService.deletePartnerAccounts(
        activeRecord.id
      );

      if (isDeleted) {
        closeDrawer();
        fetchItems();
        message.success(SUCCESS_DELETE);
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    } finally {
      hide();
    }
  };

  return (
    <>
      <ActionsWrapper placeEnd>
        <Button type="primary" onClick={getNewAccounts}>
          Получить список счетов с БЦК
        </Button>
      </ActionsWrapper>

      <PartnerAccountsTable
        items={items}
        loading={loading}
        pageSize={perPage}
        totalRows={totalRows}
        onChange={setPagination}
        onRowClick={openDrawer}
      />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.name}
        recordFields={[
          { label: 'Номер счета в БЦК', key: 'bcc_account' },
          { label: 'Партнер', key: 'admin_company' },
          { label: 'ФИО Партнера', key: 'admin_fio' },
          {
            label: 'Активный',
            key: 'is_active',
            computedValue: activeRecord?.is_active ? 'Да' : 'Нет',
          },
        ]}
        isVisible={drawerVisible}
        onEdit={openEditForm}
        onDelete={handleDelete}
        onClose={closeDrawer}
        deleteConfirmText={DELETE_CONFIRM}
      />

      <PartnerAccountsForm
        isActive={formIsActive}
        initialValues={activeRecord}
        admins={[]}
        onSuccess={fetchItems}
        onClose={closeForm}
      />
    </>
  );
}

export { PartnerAccounts };
